import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  addItemButtonLabel: PropTypes.string.isRequired,
  onAdd: PropTypes.func,
}

export default propTypes
